<template>
  <div class="container">
    <router-link class="navbar-logo" to="/" @click="closeAll">
    </router-link>
    <div class="navbar-icon" @click="openNav" :class="{ 'active': navActive }" ref="targetNavIcon">
      <Icon icon="ph:dots-three-outline-vertical-fill"></Icon>
    </div>
    <transition name="fade">
      <ul class="navbar-menu" :class="{ 'active': navActive }">
        <!-- 회사소개/서비스/솔루션/컨설팅 메뉴 그룹: 그룹 내 어디에 마우스를 올려도 전체 메가메뉴가 함께 열림 -->
        <li class="nav-group" ref="navGroup" @mouseenter="openMegaMenu" @mouseleave="closeMegaMenu">
          <ul class="nav-group-items">
            <li class="nav-item about">
              <router-link class="nav-link" to="">
                {{ $t('menu.aboutUs') }}
              </router-link>
            </li>
            <li class="nav-item service">
              <router-link class="nav-link" to="/service" @click="closeAll">
                {{ $t('menu.service') }}
              </router-link>
            </li>
            <li class="nav-item solution">
              <router-link class="nav-link" to="/solution" @click="closeAll">
                {{ $t('menu.solution') }}
              </router-link>
            </li>
            <li class="nav-item consulting">
              <router-link class="nav-link" to="/consulting" @click="closeAll">
                {{ $t('menu.consulting') }}
              </router-link>
            </li>
            <li class="nav-item" @click="closeAll">
              <router-link class="nav-link" to="/contact">
                {{ $t('menu.contact') }}
              </router-link>
            </li>
          </ul>

          <div class="mega-menu" v-show="megaMenuOpen">
            <ul class="mega-menu-col">
              <li class="nav-item" @click="closeAll">
                <router-link to="/about/history" :key="$route.fullPath">
                  {{ $t('about.history.title') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/about/references" :key="$route.fullPath">
                  {{ $t('about.references.title') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/about/map" :key="$route.fullPath">
                  {{ $t('about.map.title') }}
                </router-link>
              </li>
            </ul>

            <ul class="mega-menu-col">
              <li class="nav-item" @click="closeAll">
                <router-link to="/service/keycloak" :key="$route.fullPath">
                  {{ $t('service.title.keycloak') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/service/ai-data" :key="$route.fullPath">
                  {{ $t('service.title.aiData') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/service/cloud-consulting" :key="$route.fullPath">
                  {{ $t('service.title.cloud') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/service/maintenance" :key="$route.fullPath">
                  {{ $t('service.title.maintenance') }}
                </router-link>
              </li>
            </ul>

            <ul class="mega-menu-col">
              <li class="nav-item" @click="closeAll">
                <router-link to="/solution/nsddh" :key="$route.fullPath">
                  {{ $t('solution.title.nsddh') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/solution/iam" :key="$route.fullPath">
                  {{ $t('solution.title.iam') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/solution/sso" :key="$route.fullPath">
                  {{ $t('solution.title.ssoCategory') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/solution/two-factor" :key="$route.fullPath">
                  {{ $t('solution.title.twoFactor') }}
                </router-link>
              </li>
            </ul>

            <ul class="mega-menu-col">
              <li class="nav-item" @click="closeAll">
                <router-link to="/consulting/operation" :key="$route.fullPath">
                  {{ $t('consulting.title.operation') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/consulting/client" :key="$route.fullPath">
                  {{ $t('consulting.title.client') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/consulting/server" :key="$route.fullPath">
                  {{ $t('consulting.title.server') }}
                </router-link>
              </li>
              <li class="nav-item" @click="closeAll">
                <router-link to="/consulting/monitoring" :key="$route.fullPath">
                  {{ $t('consulting.title.monitoring') }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <li class="lang-wrap" @click="changeLocale">
          <Icon icon="ph:globe-thin"></Icon>
          {{ $t('lang') }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue'

export default {
  name: 'headerNav',
  components: { Icon },
  data () {
    return {
      navActive: false,
      megaMenuOpen: false,
      resizeTimer: null
    }
  },
  mounted () {
    this.updateMegaOffset()
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.onResize)
    clearTimeout(this.resizeTimer)
  },
  methods: {
    openNav: function () {
      this.navActive = true
      this.navShow = true
      const navButton = this.$refs.targetNavIcon
      if (navButton.classList.contains('active')) {
        this.navActive = false
      }
    },
    closeNav: function () {
      this.navActive = false
    },
    closeAll: function () {
      this.navActive = false
      this.megaMenuOpen = false
    },
    openMegaMenu: function () {
      this.updateMegaOffset()
      this.megaMenuOpen = true
    },
    closeMegaMenu: function () {
      this.megaMenuOpen = false
    },
    // 메가메뉴 뒷배경을 화면 전체 너비로 채우기 위해, nav-group이 뷰포트 왼쪽에서
    // 얼마나 떨어져 있는지 측정해 CSS 변수(--mega-offset)로 전달
    updateMegaOffset: function () {
      const navGroup = this.$refs.navGroup
      if (!navGroup) return
      const offset = navGroup.getBoundingClientRect().left
      navGroup.style.setProperty('--mega-offset', `${offset}px`)
    },
    onResize: function () {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(this.updateMegaOffset, 150)
    },
    changeLocale () {
      if (this.$i18n.locale === 'ko') return (this.$i18n.locale = 'en')
      this.$i18n.locale = 'ko'
    }
  }
}
</script>
